module.exports = "<a href={{linkurl}} target=\"{{target ? target : '_self'}}\"><span class=\"idms_Icon idms_LinkIcon {{iconclass}}\"></span></a>";